// extracted by mini-css-extract-plugin
module.exports = {"red":"#c32b08","green":"#187b50","orange":"#db6a06","lightBlue":"#19a5ce","teal":"#177692"};